import { useRoute } from '@react-navigation/native'
import { Box, Button, Heading, Text, VStack } from 'native-base'
import { useEffect, useRef, useState } from 'react'
import useLinkHandler from '../../hooks/useLinkHandler'
import FormInput from '../_shared/form/FormInput'

const EnterEmail = ({ callback }) => {
  const route = useRoute()
  const [email, setEmail] = useState('')
  const [isValid, setValid] = useState(false)
  const [isWaiting, setWaiting] = useState(false)
  const input = useRef()

  useEffect(() => {
    if (route.params?.email) {
      setEmail(route.params?.email)
      input.current?.setValue(route.params?.email)
    }
  }, [route])

  const emailValidation = () =>
    new Promise((resolve, reject) => {
      if (email.match(/\S+@\S+\.\S+/)) resolve(null)
      else
        reject(
          'Uh oh - a valid email address requires an @ followed by the domain.'
        )
    })

  const doCallback = () => {
    setWaiting(true)
    callback(email).then(() => setWaiting(false))
  }

  return (
    <VStack h="100%" w="100%" style={{ gap: 12 }}>
      <Heading fontSize={'2xl'} mt="3" color="primary.900">
        Enter your email
      </Heading>
      <Box mb={-6}>
        <FormInput
          testID="email-input"
          bg="white"
          autofocus
          defaultValue={email}
          keyboardType="email-address"
          label="Email"
          onChangeText={setEmail}
          onChangeValid={setValid}
          validation={emailValidation}
          inputAccessoryViewID={'form'}
          ref={input}
        />
      </Box>
      <Button
        isLoading={isWaiting}
        testID="continue-log-in-button"
        onPress={doCallback}
        isDisabled={!isValid}>
        Continue
      </Button>
      <Text fontSize="10px" textAlign="center" color="text.500">
        {`By continuing, you agree to Cabana by Even Health’s\n`}
        <Text
          onPress={() =>
            useLinkHandler('https://mycabana.health/terms-of-service')
          }
          underline
          color="secondary.600">
          Terms of Service
        </Text>
        {` and `}
        <Text
          onPress={() =>
            useLinkHandler('https://www.mycabana.health/privacy-policy')
          }
          underline
          color="secondary.600">
          Privacy Policy
        </Text>
        .
      </Text>
    </VStack>
  )
}

export default EnterEmail
